import { ArdoqId } from '@ardoq/api-types';
import { TimelineViewModelData, TimelineViewRenderingData } from '../types';
import { getTimelinePhasesWithHighlightBackground } from './phasesWithHighlightBackground';

type ApplyInteractiveStatesArgs = {
  hoveredItemId: ArdoqId | null;
  focusedItemId: ArdoqId | null;
  timelineViewRenderingData: Pick<
    TimelineViewRenderingData,
    'labelsInVirtualWindow' | 'phasesInVirtualWindow'
  >;
  timelineViewModelData: TimelineViewModelData;
};

export const applyInteractiveStates = ({
  timelineViewRenderingData: { labelsInVirtualWindow, phasesInVirtualWindow },
  timelineViewModelData,
  hoveredItemId,
  focusedItemId,
}: ApplyInteractiveStatesArgs) => {
  const phasesWithHighlightState = getTimelinePhasesWithHighlightBackground({
    hoveredItemId,
    focusedItemId,
    filteredViewGraphHierarchy:
      timelineViewModelData.filteredViewGraphHierarchy,
    itemPhases: phasesInVirtualWindow,
  });

  return {
    renderedItemLabels: labelsInVirtualWindow,
    renderedItemPhases: phasesWithHighlightState,
  };
};
